<template>
  <AppShell>
    <div class="page-head">
      <h1>Обзор</h1>
    </div>
    <div class="metric-grid">
      <v-card variant="flat"><v-card-title>{{ catalogs.length }}</v-card-title><v-card-text>Каталогов</v-card-text></v-card>
      <v-card variant="flat"><v-card-title>{{ clients.length }}</v-card-title><v-card-text>Клиентов</v-card-text></v-card>
      <v-card variant="flat"><v-card-title>{{ activeSessions.length }}</v-card-title><v-card-text>Активных сессий</v-card-text></v-card>
    </div>
    <v-card class="mt-6" variant="flat">
      <v-card-title>Последние сессии</v-card-title>
      <v-list>
        <v-list-item v-for="session in sessions" :key="session.id" :title="session.client_name" :subtitle="session.status" :to="`/sessions/${session.id}`" prepend-icon="mdi-table-account" />
      </v-list>
    </v-card>
  </AppShell>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue';
import { api, unwrap } from '../api/http';
import AppShell from '../components/AppShell.vue';
const catalogs = ref([]);
const clients = ref([]);
const sessions = ref([]);
const activeSessions = computed(() => sessions.value.filter((item) => item.status === 'active'));
onMounted(async () => {
  catalogs.value = unwrap(await api.get('/api/catalogs'));
  clients.value = unwrap(await api.get('/api/clients'));
  sessions.value = unwrap(await api.get('/api/sessions'));
});
</script>
